export default "__VITE_ASSET__B5g9ReVN__"